/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_register_password_stored_securely = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔒 Your password is stored securely`)
};

const zh_hans1_register_password_stored_securely = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔒 您的密码会被安全存储`)
};

const zh_hant1_register_password_stored_securely = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔒 你的密碼會被安全儲存`)
};

const fr_register_password_stored_securely = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔒 Votre mot de passe est stocké de manière sécurisée`)
};

const de_register_password_stored_securely = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔒 Dein Passwort wird sicher gespeichert`)
};

const ja_register_password_stored_securely = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔒 パスワードは安全に保存されます`)
};

const ko_register_password_stored_securely = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`🔒 비밀번호는 안전하게 저장됩니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register_password_stored_securely = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register_password_stored_securely(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register_password_stored_securely", locale)
	if (locale === "en") return en_register_password_stored_securely(inputs)
	if (locale === "zh-Hans") return zh_hans1_register_password_stored_securely(inputs)
	if (locale === "zh-Hant") return zh_hant1_register_password_stored_securely(inputs)
	if (locale === "fr") return fr_register_password_stored_securely(inputs)
	if (locale === "de") return de_register_password_stored_securely(inputs)
	if (locale === "ja") return ja_register_password_stored_securely(inputs)
	return ko_register_password_stored_securely(inputs)
};